import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { anatomyConstants } from "../../../constants/anatomyConstants";

const CameraOrientationModal = ({
  resetCamera,
  setHomeCameraView,
  goHomeCameraView,
  isHomeViewSet,
  isCameraRotationLocked,
  toggleCameraRotationLock,
  goTopView,
  goBottomView,
  goLeftView,
  goRightView,
  goFrontView,
  goBackView,
  closeCameraOrientationMode,
  isMobile,
}) => {
  // Check if mobile portrait (upside down) view
  const isMobilePortrait =
    isMobile &&
    typeof window !== "undefined" &&
    window.innerWidth < window.innerHeight;

  return (
    <div
      className={`absolute ${
        isMobilePortrait ? "bottom-20 left-2" : "bottom-1 left-28"
      } w-auto flex flex-col items-center z-50`}
    >
      <div
        className="relative flex flex-col items-center space-y-3 px-3 pt-7 pb-3 bg-white rounded-lg shadow-lg border border-gray-200 w-44"
        style={{
          "--main-color": anatomyConstants.mainColor,
          "--main-color-bold": anatomyConstants.mainColorBold,
        }}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            closeCameraOrientationMode();
          }}
          aria-label="Close"
          className="absolute top-2 right-2 w-5 h-5 rounded-full bg-gray-100 border border-[#0000001A] shadow-sm flex items-center justify-center text-gray-700 hover:bg-gray-200 z-10"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <button
          title="Resets the camera to its starting position and orientation."
          onClick={(e) => {
            e.stopPropagation();
            resetCamera();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-[#757575] bg-white rounded border border-[#0000001A] hover:bg-gray-100"
        >
          Reset Camera
        </button>
        <button
          title={
            isCameraRotationLocked
              ? "Unlocks camera rotation."
              : "Locks camera rotation to prevent accidental movement."
          }
          onClick={(e) => {
            e.stopPropagation();
            toggleCameraRotationLock();
          }}
          className={`w-full py-2 px-3 text-sm font-inter font-medium text-[#757575] rounded border border-[#0000001A] transition
    ${
      isCameraRotationLocked
        ? "bg-gray-100 cursor-default"
        : "bg-white hover:bg-gray-100 cursor-pointer"
    }`}
        >
          <span className="inline-flex items-center gap-2">
            {isCameraRotationLocked ? (
              <>
                <LockIcon fontSize="small" />
                <span>Unlock Camera</span>
              </>
            ) : (
              <>
                <LockOpenIcon fontSize="small" />
                <span>Lock Camera</span>
              </>
            )}
          </span>
        </button>

        <button
          title="Sets the current camera position and orientation as the home view."
          onClick={(e) => {
            e.stopPropagation();
            setHomeCameraView();
          }}
          className="w-full py-2 px-3 text-sm font-inter font-medium text-[#757575] bg-white rounded border border-[#0000001A] hover:bg-gray-100"
        >
          Set Home View
        </button>
        <button
          title="Moves the camera to the previously set home view."
          onClick={(e) => {
            e.stopPropagation();
            goHomeCameraView();
          }}
          disabled={!isHomeViewSet}
          className={`w-full py-2 px-3 text-sm font-inter font-semibold text-white rounded transition
    ${
      isHomeViewSet
        ? "bg-[var(--main-color)] hover:bg-[var(--main-color-bold)] cursor-pointer border border-[#0000001A]"
        : "bg-gray-400 text-gray-200 cursor-not-allowed border border-[#0000001A]"
    }`}
        >
          Go to Home View
        </button>
        <div className="view-buttons flex flex-wrap justify-center gap-2 m-2">
          <button
            onClick={goTopView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Top View"
          >
            <ArrowUpwardIcon />
          </button>
          <button
            onClick={goBottomView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Bottom View"
          >
            <ArrowDownwardIcon />
          </button>
          <button
            onClick={goLeftView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Left View"
          >
            <ArrowLeftIcon />
          </button>
          <button
            onClick={goRightView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Right View"
          >
            <ArrowRightIcon />
          </button>
          <button
            onClick={goFrontView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Front View"
          >
            <ArrowForwardIcon />
          </button>
          <button
            onClick={goBackView}
            className="p-2 bg-gray-100 rounded hover:bg-gray-200 text-[var(--main-color)]"
            title="Back View"
          >
            <ArrowBackIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CameraOrientationModal;
